/* Bowkart story & reel player — WhatsApp / Instagram style full-screen viewer.
   Used by sections/bk-stories.liquid (status circles) and sections/bowkart-shoppable-video.liquid (reels).
   Data: <script type="application/json" data-bk-stories="ID">[groups]</script>
   Openers: any element with data-bk-story-open="ID:index" (optional data-bk-story-sound="1").
   Group: {id, title, ts, avatar, items:[{type:'image'|'video', src, poster}], product:{...}|null} */
(function () {
  'use strict';
  if (window.BkStories) return;

  var SEEN_KEY = 'bkStoriesSeen';
  var IMAGE_MS = 5000;
  var dataCache = {};

  function readSeen() {
    try { return JSON.parse(window.localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function isSeen(id) { return !!readSeen()[id]; }
  function markSeen(id) {
    if (!id) return;
    try {
      var s = readSeen();
      s[id] = Date.now();
      var keys = Object.keys(s);
      if (keys.length > 300) {
        keys.sort(function (a, b) { return s[a] - s[b]; }).slice(0, keys.length - 300).forEach(function (k) { delete s[k]; });
      }
      window.localStorage.setItem(SEEN_KEY, JSON.stringify(s));
    } catch (e) { /* storage blocked – ignore */ }
    var els = document.querySelectorAll('[data-bk-story-id]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-bk-story-id') === id) els[i].classList.add('is-seen');
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ago(ts) {
    ts = Number(ts || 0);
    if (!ts) return '';
    var s = Math.max(0, Date.now() / 1000 - ts);
    if (s < 3600) return Math.max(1, Math.round(s / 60)) + 'm ago';
    if (s < 86400) return Math.round(s / 3600) + 'h ago';
    var d = Math.round(s / 86400);
    if (d < 7) return d + 'd ago';
    if (d < 60) return Math.round(d / 7) + 'w ago';
    return '';
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  var ICON = {
    close: '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/></svg>',
    muted: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M17 9l4 6M21 9l-4 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
    sound: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 010 7M19 6a8.5 8.5 0 010 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>',
    bag: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linejoin="round"/><path d="M9 8V6a3 3 0 016 0v2" stroke="currentColor" stroke-width="1.8" fill="none"/></svg>'
  };

  function Viewer(groups, startIndex, opts) {
    this.groups = groups;
    this.opts = opts || {};
    this.gi = Math.max(0, Math.min(startIndex || 0, groups.length - 1));
    this.ii = 0;
    this.muted = !this.opts.sound;
    this.paused = false;
    this.holding = false;
    this.elapsed = 0;
    this.last = 0;
    this.ready = false;
    this.raf = 0;
    this.selectedVariant = null;
    this.build();
    this.show(this.gi, 0);
  }

  Viewer.prototype.build = function () {
    var self = this;
    var el = document.createElement('div');
    el.className = 'bk-sv' + (this.opts.mode === 'reel' ? ' bk-sv--reel' : '');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', this.opts.mode === 'reel' ? 'Video player' : 'Stories');
    el.innerHTML =
      '<div class="bk-sv__backdrop"></div>' +
      '<div class="bk-sv__stage">' +
        '<button type="button" class="bk-sv__nav bk-sv__nav--prev" aria-label="Previous">' + ICON.prev + '</button>' +
        '<div class="bk-sv__frame">' +
          '<div class="bk-sv__media"></div>' +
          '<div class="bk-sv__spin" aria-hidden="true"></div>' +
          '<div class="bk-sv__shade bk-sv__shade--top"></div>' +
          '<div class="bk-sv__shade bk-sv__shade--bottom"></div>' +
          '<div class="bk-sv__hit" aria-hidden="true"></div>' +
          '<div class="bk-sv__top">' +
            '<div class="bk-sv__bars"></div>' +
            '<div class="bk-sv__head">' +
              '<span class="bk-sv__avatar"></span>' +
              '<span class="bk-sv__who"><b class="bk-sv__title"></b><small class="bk-sv__time"></small></span>' +
              '<button type="button" class="bk-sv__btn bk-sv__sound" aria-label="Sound" hidden></button>' +
              '<button type="button" class="bk-sv__btn bk-sv__close" aria-label="Close">' + ICON.close + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="bk-sv__paused" aria-hidden="true"><i></i><i></i></div>' +
          '<div class="bk-sv__foot"></div>' +
        '</div>' +
        '<button type="button" class="bk-sv__nav bk-sv__nav--next" aria-label="Next">' + ICON.next + '</button>' +
      '</div>';
    this.el = el;
    this.$ = function (sel) { return el.querySelector(sel); };
    this.media = this.$('.bk-sv__media');
    this.bars = this.$('.bk-sv__bars');
    this.foot = this.$('.bk-sv__foot');
    this.soundBtn = this.$('.bk-sv__sound');

    this.$('.bk-sv__close').addEventListener('click', function () { self.close(); });
    this.$('.bk-sv__backdrop').addEventListener('click', function () { self.close(); });
    this.$('.bk-sv__nav--prev').addEventListener('click', function () { self.prevGroup(); });
    this.$('.bk-sv__nav--next').addEventListener('click', function () { self.nextGroup(); });
    this.soundBtn.addEventListener('click', function () { self.setMuted(!self.muted); });

    // tap left/right, hold to pause, swipe to change / close
    var hit = this.$('.bk-sv__hit');
    var sx = 0, sy = 0, st = 0, holdTimer = 0, active = false;
    hit.addEventListener('pointerdown', function (e) {
      active = true; sx = e.clientX; sy = e.clientY; st = Date.now();
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { if (!self.el) return; self.holding = true; self.el.classList.add('is-holding'); self.pauseMedia(); }, 220);
    });
    function end(e, cancelled) {
      if (!active) return;
      active = false;
      clearTimeout(holdTimer);
      if (!self.el) return;
      var wasHolding = self.holding;
      self.holding = false;
      self.el.classList.remove('is-holding');
      var dx = e.clientX - sx, dy = e.clientY - sy, adx = Math.abs(dx), ady = Math.abs(dy);
      if (!cancelled && ady > 70 && ady > adx) {
        if (dy > 0) { self.close(); return; }
        self.nextGroup(); return;
      }
      if (!cancelled && adx > 50 && adx > ady) {
        if (dx < 0) self.nextGroup(); else self.prevGroup();
        return;
      }
      if (self.cardHold) { self.cardHold = false; self.resumeMedia(); return; }
      if (wasHolding || cancelled || Date.now() - st > 400) { self.resumeMedia(); return; }
      var r = hit.getBoundingClientRect();
      if (e.clientX - r.left < r.width * 0.32) self.prev(); else self.next();
    }
    hit.addEventListener('pointerup', function (e) { end(e, false); });
    hit.addEventListener('pointercancel', function (e) { end(e, true); });
    hit.addEventListener('contextmenu', function (e) { e.preventDefault(); });

    this.onKey = function (e) {
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowRight') self.next();
      else if (e.key === 'ArrowLeft') self.prev();
      else if (e.key === ' ') { e.preventDefault(); self.paused ? self.resumeMedia() : self.pauseMedia(); }
    };
    this.onVis = function () { if (document.hidden) self.pauseMedia(); else if (!self.holding) self.resumeMedia(); };
    this.onPop = function () {
      if (self.ignorePop) { self.ignorePop = false; return; }
      self.teardown();
    };
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('visibilitychange', this.onVis);

    document.body.appendChild(el);
    document.documentElement.classList.add('bk-sv-lock');
    try {
      history.pushState({ bkSv: 1 }, '');
      this.pushed = true;
      window.addEventListener('popstate', this.onPop);
    } catch (e) { this.pushed = false; }
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    this.$('.bk-sv__close').focus({ preventScroll: true });
  };

  Viewer.prototype.group = function () { return this.groups[this.gi]; };

  Viewer.prototype.show = function (gi, ii) {
    var g = this.groups[gi];
    if (!g) { this.close(); return; }
    if (!g.items || !g.items.length) {
      // nothing to play in this group, move on
      if (gi < this.groups.length - 1) return this.show(gi + 1, 0);
      this.close(); return;
    }
    var groupChanged = gi !== this.gi || !this.bars.children.length;
    this.gi = gi;
    this.ii = Math.max(0, Math.min(ii, g.items.length - 1));
    if (groupChanged || this.bars.children.length !== g.items.length) this.renderGroup(g);
    markSeen(g.id);
    if (typeof this.opts.onShow === 'function') this.opts.onShow(this.gi);
    this.renderItem(g.items[this.ii]);
    this.$('.bk-sv__nav--prev').disabled = this.gi === 0;
    this.$('.bk-sv__nav--next').disabled = this.gi >= this.groups.length - 1;
  };

  Viewer.prototype.renderGroup = function (g) {
    var bars = '';
    for (var i = 0; i < g.items.length; i++) bars += '<span class="bk-sv__bar"><i></i></span>';
    this.bars.innerHTML = bars;
    this.$('.bk-sv__avatar').innerHTML = g.avatar ? '<img src="' + esc(g.avatar) + '" alt="" width="36" height="36">' : '';
    this.$('.bk-sv__title').textContent = g.title || '';
    this.$('.bk-sv__time').textContent = ago(g.ts) || (g.sub || '');
    this.selectedVariant = null;
    this.renderProduct(g.product);
    var f = this.$('.bk-sv__frame');
    f.classList.remove('is-enter');
    void f.offsetWidth;
    f.classList.add('is-enter');
  };

  Viewer.prototype.renderProduct = function (p) {
    var self = this;
    this.foot.innerHTML = '';
    this.el.classList.toggle('has-product', !!p);
    if (!p) return;
    var price = '<b>' + esc(p.price) + '</b>';
    if (p.compare && p.off > 0) price += '<s>' + esc(p.compare) + '</s><em>' + p.off + '% off</em>';
    var sizes = '';
    var variants = p.variants || [];
    var canPick = variants.length > 1 && variants.length <= 20;
    if (canPick && p.available) {
      sizes = '<div class="bk-sv__sizes" role="group" aria-label="Choose size">';
      variants.forEach(function (v) {
        sizes += '<button type="button" class="bk-sv__size" data-v="' + esc(v.id) + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>';
      });
      sizes += '</div>';
    }
    var cta;
    if (!p.available) cta = '<a class="bk-sv__cta is-ghost" href="' + esc(p.url) + '">Sold out · View similar</a>';
    else if (p.single || canPick) cta = '<button type="button" class="bk-sv__cta" data-add' + (canPick ? ' data-needs-size' : '') + '>' + ICON.bag + '<span>' + (canPick ? 'Select a size' : 'Add to bag') + '</span></button>';
    else cta = '<a class="bk-sv__cta" href="' + esc(p.url) + '">' + ICON.bag + '<span>Choose options</span></a>';

    this.foot.innerHTML =
      '<div class="bk-sv__card">' +
        '<a class="bk-sv__card-link" href="' + esc(p.url) + '">' +
          (p.image ? '<img class="bk-sv__card-img" src="' + esc(p.image) + '" alt="" width="56" height="70" loading="lazy">' : '') +
          '<span class="bk-sv__card-info"><span class="bk-sv__card-title">' + esc(p.title) + '</span>' +
          '<span class="bk-sv__card-price">' + price + '</span></span>' +
          '<span class="bk-sv__card-go" aria-hidden="true">' + ICON.next + '</span>' +
        '</a>' +
        sizes +
        '<div class="bk-sv__msg" aria-live="polite"></div>' +
        cta +
      '</div>';

    // pause while the shopper interacts with the card, resume after
    var card = this.foot.querySelector('.bk-sv__card');
    card.addEventListener('pointerdown', function () { self.cardHold = true; self.pauseMedia(); });
    this.foot.querySelectorAll('.bk-sv__size').forEach(function (b) {
      b.addEventListener('click', function () {
        self.foot.querySelectorAll('.bk-sv__size').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        self.selectedVariant = b.getAttribute('data-v');
        var btn = self.foot.querySelector('[data-add]');
        if (btn) { btn.removeAttribute('data-needs-size'); btn.querySelector('span').textContent = 'Add to bag'; }
      });
    });
    var add = this.foot.querySelector('[data-add]');
    if (add) add.addEventListener('click', function () {
      var id = p.single ? p.variant : self.selectedVariant;
      var msg = self.foot.querySelector('.bk-sv__msg');
      if (!id) {
        msg.textContent = 'Please choose a size first';
        var s = self.foot.querySelector('.bk-sv__sizes');
        if (s) { s.classList.remove('is-shake'); void s.offsetWidth; s.classList.add('is-shake'); }
        return;
      }
      add.disabled = true;
      add.querySelector('span').textContent = 'Adding…';
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () {
        add.classList.add('is-done');
        add.querySelector('span').textContent = 'Added to bag';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () {
          self.close();
          if (window.BowkartCart && typeof window.BowkartCart.open === 'function') window.BowkartCart.open();
          else window.location.href = root() + 'cart';
        }, 550);
      }).catch(function (err) {
        add.disabled = false;
        add.querySelector('span').textContent = 'Add to bag';
        msg.textContent = (err && (err.description || err.message)) || 'Could not add to bag. Please try again.';
      });
    });
  };

  Viewer.prototype.renderItem = function (item) {
    var self = this;
    this.stopLoop();
    this.ready = false;
    this.elapsed = 0;
    this.paused = false;
    this.el.classList.remove('is-paused');
    this.el.classList.add('is-loading');
    var old = this.media.querySelector('video');
    if (old) { try { old.pause(); old.removeAttribute('src'); old.load(); } catch (e) {} }
    this.media.innerHTML = '';
    this.video = null;
    this.updateBars(0);

    if (item.type === 'video') {
      var v = document.createElement('video');
      v.className = 'bk-sv__el';
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.preload = 'auto';
      v.muted = this.muted;
      if (item.poster) v.poster = item.poster;
      v.src = item.src;
      this.media.appendChild(v);
      this.video = v;
      this.soundBtn.hidden = false;
      this.renderSound();
      v.addEventListener('playing', function () { if (!self.el) return; self.el.classList.remove('is-loading'); self.ready = true; });
      v.addEventListener('waiting', function () { if (self.el) self.el.classList.add('is-loading'); });
      v.addEventListener('ended', function () { if (self.el && self.video === v) self.next(); });
      v.addEventListener('error', function () { setTimeout(function () { if (self.el && self.video === v) self.next(); }, 600); });
      this.playVideo();
      this.loop();
    } else {
      this.soundBtn.hidden = true;
      var img = new Image();
      img.className = 'bk-sv__el';
      img.alt = (this.group() && this.group().title) || '';
      img.decoding = 'async';
      img.onload = function () { if (!self.el) return; self.el.classList.remove('is-loading'); self.ready = true; self.last = performance.now(); };
      img.onerror = function () { if (!self.el) return; self.el.classList.remove('is-loading'); self.ready = true; self.last = performance.now(); };
      img.src = item.src;
      this.media.appendChild(img);
      this.loop();
    }
    this.preloadNext();
  };

  Viewer.prototype.playVideo = function () {
    var self = this, v = this.video;
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      // browser refused sound – fall back to muted autoplay
      if (!v.muted) { self.muted = true; v.muted = true; self.renderSound(); v.play().catch(function () {}); }
    });
  };

  Viewer.prototype.renderSound = function () {
    this.soundBtn.innerHTML = this.muted ? ICON.muted : ICON.sound;
    this.soundBtn.setAttribute('aria-label', this.muted ? 'Turn sound on' : 'Mute');
  };
  Viewer.prototype.setMuted = function (m) {
    this.muted = m;
    if (this.video) { this.video.muted = m; if (!m && this.video.paused && !this.paused) this.playVideo(); }
    this.renderSound();
  };

  Viewer.prototype.preloadNext = function () {
    var g = this.group(), nxt = null;
    if (g && this.ii + 1 < g.items.length) nxt = g.items[this.ii + 1];
    else if (this.groups[this.gi + 1] && this.groups[this.gi + 1].items) nxt = this.groups[this.gi + 1].items[0];
    if (nxt && nxt.type === 'image') { var i = new Image(); i.src = nxt.src; }
    else if (nxt && nxt.poster) { var j = new Image(); j.src = nxt.poster; }
  };

  Viewer.prototype.loop = function () {
    var self = this;
    this.last = performance.now();
    var tick = function (now) {
      if (!self.el) return;
      var dt = now - self.last;
      self.last = now;
      var g = self.group(), item = g && g.items[self.ii];
      if (!item) return;
      if (item.type === 'video') {
        var v = self.video;
        if (v && v.duration) self.updateBars(v.currentTime / v.duration);
      } else if (self.ready && !self.paused) {
        self.elapsed += dt;
        var pct = self.elapsed / IMAGE_MS;
        self.updateBars(pct);
        if (pct >= 1) { self.next(); return; }
      }
      self.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  };
  Viewer.prototype.stopLoop = function () { cancelAnimationFrame(this.raf); this.raf = 0; };

  Viewer.prototype.updateBars = function (pct) {
    var bars = this.bars.children;
    for (var i = 0; i < bars.length; i++) {
      var w = i < this.ii ? 1 : (i === this.ii ? Math.max(0, Math.min(1, pct)) : 0);
      bars[i].firstChild.style.transform = 'scaleX(' + w + ')';
    }
  };

  Viewer.prototype.pauseMedia = function () {
    this.paused = true;
    this.el && this.el.classList.add('is-paused');
    if (this.video) this.video.pause();
  };
  Viewer.prototype.resumeMedia = function () {
    if (this.cardHold) return;
    this.paused = false;
    this.el && this.el.classList.remove('is-paused');
    this.last = performance.now();
    if (this.video) this.playVideo();
  };

  Viewer.prototype.next = function () {
    this.cardHold = false;
    var g = this.group();
    if (g && this.ii < g.items.length - 1) this.show(this.gi, this.ii + 1);
    else this.nextGroup();
  };
  Viewer.prototype.prev = function () {
    this.cardHold = false;
    if (this.ii > 0) this.show(this.gi, this.ii - 1);
    else if (this.gi > 0) this.show(this.gi - 1, 0);
    else this.show(this.gi, 0);
  };
  Viewer.prototype.nextGroup = function () {
    this.cardHold = false;
    if (this.gi < this.groups.length - 1) this.show(this.gi + 1, 0);
    else this.close();
  };
  Viewer.prototype.prevGroup = function () {
    this.cardHold = false;
    if (this.gi > 0) this.show(this.gi - 1, 0);
    else this.show(0, 0);
  };

  Viewer.prototype.close = function () {
    if (!this.el) return;
    if (this.pushed && history.state && history.state.bkSv) {
      this.ignorePop = true;
      try { history.back(); } catch (e) {}
    }
    this.teardown();
  };
  Viewer.prototype.teardown = function () {
    if (!this.el) return;
    var el = this.el;
    this.el = null;
    this.stopLoop();
    if (this.video) { try { this.video.pause(); } catch (e) {} }
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('visibilitychange', this.onVis);
    var self = this;
    // keep the popstate listener long enough to swallow our own history.back()
    setTimeout(function () { window.removeEventListener('popstate', self.onPop); }, 400);
    document.documentElement.classList.remove('bk-sv-lock');
    el.classList.remove('is-open');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 220);
    if (typeof this.opts.onClose === 'function') this.opts.onClose(this.gi);
    if (this.opener && this.opener.focus) { try { this.opener.focus({ preventScroll: true }); } catch (e) {} }
    if (BkStories.current === this) BkStories.current = null;
  };

  function getData(id) {
    if (dataCache[id]) return dataCache[id];
    var nodes = document.querySelectorAll('script[data-bk-stories]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-bk-stories') === id) {
        try { dataCache[id] = JSON.parse(nodes[i].textContent || '[]'); } catch (e) { dataCache[id] = []; }
        return dataCache[id];
      }
    }
    return [];
  }

  var BkStories = {
    current: null,
    open: function (groups, index, opts) {
      if (BkStories.current) BkStories.current.teardown();
      if (!groups || !groups.length) return null;
      BkStories.current = new Viewer(groups, index, opts);
      return BkStories.current;
    },
    isSeen: isSeen,
    markSeen: markSeen
  };
  window.BkStories = BkStories;

  function openFrom(el) {
    var val = el.getAttribute('data-bk-story-open') || '';
    var cut = val.lastIndexOf(':');
    if (cut < 0) return;
    var id = val.slice(0, cut), idx = parseInt(val.slice(cut + 1), 10) || 0;
    var data = getData(id);
    if (!data.length) return;
    // follow the on-screen order (unseen stories are moved to the front)
    var rail = el.closest('[data-bk-story-rail]');
    var order = [], start = 0;
    if (rail) {
      var openers = rail.querySelectorAll('[data-bk-story-open]');
      for (var i = 0; i < openers.length; i++) {
        var v = openers[i].getAttribute('data-bk-story-open');
        var n = parseInt(v.slice(v.lastIndexOf(':') + 1), 10) || 0;
        if (data[n]) { if (openers[i] === el) start = order.length; order.push(n); }
      }
    }
    if (!order.length) { for (var k = 0; k < data.length; k++) order.push(k); start = idx; }
    var groups = order.map(function (n) { return data[n]; });
    var viewer = BkStories.open(groups, start, {
      sound: el.getAttribute('data-bk-story-sound') === '1',
      mode: el.getAttribute('data-bk-story-mode') || 'story',
      onClose: function (gi) {
        if (!rail) return;
        var target = rail.querySelectorAll('[data-bk-story-open]')[gi];
        var item = target && (target.closest('[data-bk-story-id]') || target);
        if (item) {
          var left = item.offsetLeft - (rail.clientWidth - item.clientWidth) / 2;
          try { rail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (e) { rail.scrollLeft = left; }
        }
        document.dispatchEvent(new CustomEvent('bk:stories:closed', { detail: { id: id } }));
      }
    });
    if (viewer) viewer.opener = el;
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-bk-story-open]');
    if (!el) return;
    e.preventDefault();
    openFrom(el);
  });

  // mark seen circles and move them behind the unseen ones (WhatsApp / Instagram behaviour)
  function initRails(scope) {
    var rails = (scope || document).querySelectorAll('[data-bk-story-rail]');
    var seen = readSeen();
    for (var r = 0; r < rails.length; r++) {
      var rail = rails[r];
      if (rail.hasAttribute('data-bk-ready')) continue;
      rail.setAttribute('data-bk-ready', '');
      var items = rail.querySelectorAll('[data-bk-story-id]');
      var seenEls = [];
      for (var i = 0; i < items.length; i++) {
        if (seen[items[i].getAttribute('data-bk-story-id')]) { items[i].classList.add('is-seen'); seenEls.push(items[i]); }
      }
      if (rail.hasAttribute('data-bk-story-sort') && seenEls.length && seenEls.length < items.length) {
        seenEls.forEach(function (el) { rail.appendChild(el); });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initRails(); });
  else initRails();
  document.addEventListener('shopify:section:load', function (e) { dataCache = {}; initRails(e.target); });
})();
